import { google } from '@google-cloud/retail/build/protos/protos';
import { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import { useCurrentLocale } from '@/shared/utils/client';

import { fetchCompleteQuery } from '../api/endpoints';

export function useSearchSuggestions() {
  const locale = useCurrentLocale();
  const [suggestions, setSuggestions] = useState<
    Array<google.cloud.retail.v2beta.CompleteQueryResponse.ICompletionResult>
  >([]);
  const [attributionToken, setAttributionToken] = useState<string | null>(null);
  const [searchQueryParam, setSearchQueryParam] = useState('');
  const [isAttrbutionTokenLoaded, setIsAttributionTokenLoaded] =
    useState(false);
  const debounceQuery = useDebouncedCallback((value) => {
    setSearchQueryParam(value.trim());
  }, 300);

  useEffect(() => {
    setIsAttributionTokenLoaded(false);
    if (searchQueryParam.trim() === '') {
      return;
    }

    fetchCompleteQuery(searchQueryParam, locale).then((response) => {
      if (!response) {
        return;
      }

      setIsAttributionTokenLoaded(true);
      setSuggestions(response.completionResults || []);
      setAttributionToken(response.attributionToken || null);
    });
  }, [searchQueryParam]);

  return {
    suggestions,
    updateSuggestion: debounceQuery,
    attributionToken,
    isAttrbutionTokenLoaded,
  };
}
